import { z } from 'zod';

const environmentSchema = z.object({
  VITE_API_BASE_URL: z
    .string()
    .min(1)
    .refine((value) => value.startsWith('/') || URL.canParse(value), 'Must be a URL or root path.')
    .transform((value) => value.replace(/\/$/, '')),
  VITE_LOGIN_URL: z.url(),
  VITE_LEGACY_ADMIN_URL: z.url().optional(),
  VITE_GOOGLE_MAPS_API_KEY: z.string().optional().default(''),
  VITE_DISABLED_FEATURES: z.string().optional().default(''),
});

const result = environmentSchema.safeParse(import.meta.env);

if (!result.success) {
  throw new Error(`Invalid application environment: ${z.prettifyError(result.error)}`);
}

export const environment = Object.freeze({
  apiBaseUrl: result.data.VITE_API_BASE_URL,
  loginUrl: publicUrl(result.data.VITE_LOGIN_URL),
  legacyAdminUrl: result.data.VITE_LEGACY_ADMIN_URL
    ? publicUrl(result.data.VITE_LEGACY_ADMIN_URL)
    : undefined,
  googleMapsApiKey: result.data.VITE_GOOGLE_MAPS_API_KEY,
  disabledFeatures: result.data.VITE_DISABLED_FEATURES.split(',')
    .map((value) => value.trim())
    .filter(Boolean),
});

function publicUrl(configuredUrl: string): string {
  const url = new URL(configuredUrl);
  const runningPublicly = !['localhost', '127.0.0.1'].includes(window.location.hostname);
  if (runningPublicly && ['localhost', '127.0.0.1'].includes(url.hostname)) {
    url.protocol = window.location.protocol;
    url.hostname = window.location.hostname;
    url.port = '';
  }
  return url.toString();
}

export function isFeatureEnabled(
  feature: string,
  disabledFeatures: readonly string[] = environment.disabledFeatures,
): boolean {
  return !disabledFeatures.includes(feature);
}
